import DateUtils from './DateUtils';

export class Calendar {
	root;
	min;
	max;

	messages = {
		initMsg: 'Wybierz apartament',
		loadMsg: 'Trwa pobieranie danych...',
		errMsg: 'Coś poszło nie tak 😟',
		errBtnMsg: 'Spróbuj ponownie',
	};

	displayed = {
		date: null,
		year: null,
		month: null,
	};

	constructor(root) {
		this.root = root;
		this.permanent = root.dataset.apartment ? true : false;
		this.id = root.dataset.apartment;
		this._init();
	}

	isPermanent = () => this.permanent;

	getApartmentId = () => this.id;

	displayData({ getDaysData, currDate, min, max }) {
		this.root.innerHTML = this._calendarMarkup();
		this._addHandlers();
		this.getDaysData = getDaysData;
		this._setMinMax(min, max);
		const { year, month } = DateUtils.object(currDate);
		this._updateView(year, month);
	}

	_updateView(year, month) {
		this._setDisplayed(year, month);
		this._setMonthInputValue(year, month);
		const days = this.getDaysData(year, month);
		this.root.querySelector('#days').innerHTML = this._daysMarkup(days);
	}

	_setMinMax(min, max) {
		this.max = max;
		this.min = min;
		this._setMonthInputMinMax(min, max);
	}

	_setDisplayed(year, month) {
		this.displayed.month = month;
		this.displayed.year = year;
		this.displayed.date = new Date(year, month, 1);
	}

	_setMonthInputMinMax(min, max) {
		const monthContainer = this.root.querySelector('#displayedMonth');
		const { year: minYear, month: minMonth } = DateUtils.object(min);
		const { year: maxYear, month: maxMonth } = DateUtils.object(max);
		monthContainer.min = DateUtils.monthInputPattern(minYear, minMonth);
		monthContainer.max = DateUtils.monthInputPattern(maxYear, maxMonth);
	}

	_setMonthInputValue(year, month) {
		const monthContainer = this.root.querySelector('#displayedMonth');
		monthContainer.value = DateUtils.monthInputPattern(year, month);
	}

	_handleLeftArrowClick = e => {
		e.preventDefault();
		const { date, month, year } = this.displayed;
		if (DateUtils.isSameMonth(date, this.min)) return;
		const { prevYear, prevMonth } = DateUtils.prevMonth(year, month);
		this._updateView(prevYear, prevMonth);
	};

	_handleRightArrowClick = e => {
		e.preventDefault();
		const { month, year, date } = this.displayed;
		if (DateUtils.isSameMonth(date, this.max)) return;
		const { nextYear, nextMonth } = DateUtils.nextMonth(year, month);
		this._updateView(nextYear, nextMonth);
	};

	_handleInputChange = e => {
		e.preventDefault();
		const [year, month] = e.target.value.split('-');
		const date = DateUtils.from(year, month);
		if (date > this.max || date < this.min) return;
		this._updateView(+year, +month - 1);
	};

	_handleInputBlur = e => {
		e.preventDefault();
		const [year, month] = e.target.value.split('-');
		const date = DateUtils.from(year, month);
		const { year: minYear, month: minMonth } = DateUtils.object(this.min);
		const { year: maxYear, month: maxMonth } = DateUtils.object(this.max);
		if (date > this.max) this._updateView(maxYear, maxMonth);
		if (date < this.min) this._updateView(minYear, minMonth);
	};

	_addHandlers() {
		const arrowLeft = this.root.querySelector('#arrowLeft');
		const arrowRight = this.root.querySelector('#arrowRight');
		const monthInput = this.root.querySelector('#displayedMonth');
		monthInput?.addEventListener('blur', this._handleInputBlur);
		monthInput?.addEventListener('change', this._handleInputChange);
		arrowLeft?.addEventListener('click', this._handleLeftArrowClick);
		arrowRight?.addEventListener('click', this._handleRightArrowClick);
	}

	error() {
		this.root.innerHTML = `
		<div class="calendar__error">
			<p>${this.messages.errMsg}</p>
			<button class="calendar__error-btn" id="errorBtn">
			${this.messages.errBtnMsg}
			</button>
		</div>
		`;
		const errorBtn = this.root.querySelector('#errorBtn');
		return errorBtn;
	}

	setLoading() {
		this.root.innerHTML = `
		<div class="calendar__loading">
		<i class="ph ph-circle-notch"></i>
		<p>${this.messages.loadMsg}</p>
		</div>
		`;
	}

	_init() {
		this.root.innerHTML = `
		<div class="calendar__init">
		<p>${this.messages.initMsg}</p>
		</div>`;
	}

	_calendarMarkup() {
		const markup = `
		<div class="calendar__top">
		  <button class="calendar__top-arrows-item calendar__top-arrows-item-left" id="arrowLeft" aria-label="poprzedni miesiąc" tabindex="-1">
        <i class="ph ph-arrow-circle-left"></i>
      </button>
	  	<input type="month" class="calendar__top-date"  id="displayedMonth" aria-label="wybierz miesiąc" tabindex="-1"></input>
			<button class="calendar__top-arrows-item calendar__top-arrows-item-right" id="arrowRight" aria-label="następny miesiąc" tabindex="-1">
        <i class="ph ph-arrow-circle-right"></i>
      </button>
		</div>
	  <div class="calendar__box">
	    <div class="calendar__week-days">
	      <span class="calendar__week-days-item">pon.</span>
	      <span class="calendar__week-days-item">wt.</span>
	      <span class="calendar__week-days-item">śr.</span>
	      <span class="calendar__week-days-item">czw.</span>
	      <span class="calendar__week-days-item">pt.</span>
	      <span class="calendar__week-days-item">sob.</span>
	      <span class="calendar__week-days-item">nd.</span>
	    </div>
	    <div class="calendar__days" id="days">
	    </div>
	  </div>
	  `;
		return markup;
	}

	_daysMarkup(days) {
		let markup = '';
		if (!days) return;
		const firstDay = days[0];
		const firstWeekDay =
			firstDay.date.getDay() === 0 ? 7 : firstDay.date.getDay();

		for (let i = 1; i < firstWeekDay; i++) {
			markup += ` <div class="calendar__days-item">
        <span class="calendar__days-item-day"></span>
      </div>`;
		}
		days.forEach(day => {
			const dayMarkup = ` <div class="calendar__days-item ${
				day.occupied
					? 'calendar__days-item--occupied'
					: 'calendar__days-item--available'
			}">
        <span class="calendar__days-item-day">${day.date.getDate()}</span>
        </div>`;
			markup += dayMarkup;
		});
		return markup;
	}
}
